import type { DlsgPolicy } from '@repo/api-gw-sdk';

import { Wizard } from '@/components/wizard/Wizard';

import {
  addIdsToDlsgPolicy,
  StorageGatewayWizardFlow,
  type StorageGatewayWizardState,
} from './storageGatewayWizardFlow';

const isSpecificPrefixes = (policy: DlsgPolicy) => {
  return (
    policy.policyPlan.dlsgConfig.length > 1 ||
    policy.policyPlan.dlsgConfig[0].pathPrefixes.length > 1 ||
    (policy.policyPlan.dlsgConfig[0].pathPrefixes.length &&
      policy.policyPlan.dlsgConfig[0].pathPrefixes[0] !== '' &&
      policy.policyPlan.dlsgConfig[0].pathPrefixes[0] !== '/')
  );
};

export const StorageGatewayWizard = ({
  onSave,
  onClose,
  entity,
}: {
  onSave: () => Promise<void>;
  onClose: () => void;
  entity: DlsgPolicy;
}) => {
  const prefixesSelectionMode = isSpecificPrefixes(entity) ? 'specific' : 'all';

  return (
    <Wizard<StorageGatewayWizardState>
      hideBackArrow={true}
      onAbort={onClose}
      onFinish={async () => {
        await onSave();
        return true;
      }}
      initialStep={{ stepIndex: entity.id ? 1 : 0 }}
      flow={[StorageGatewayWizardFlow]}
      initialState={{
        dlsgPolicy: { ...addIdsToDlsgPolicy(entity) },
        initialResourcesIds: entity?.resourceInclusion || [],
        prefixesSelectionMode,
        allObjectsPolicyConfig: { ...entity.policyPlan.dlsgConfig[0] },
      }}
      title='Connect resources to Gateway'
    />
  );
};
